module.exports = __webpack_public_path__ + "img/logo.a311390e.jpg";